<div class="admin-container" [hidden]="!isLoaded">
  <mat-toolbar class="no-background">
    <span>【管理者用】送金処理管理<span style="font-size: 14px; margin-left: 30px;">「出金依頼ID」以外をクリックで詳細へ</span></span>
    <span class="spacer"></span>
    <mat-checkbox [(ngModel)]="showCompleted" (change)="onToggleCompleted()" style="margin-right: 32px;">
      送金済・完了・単独未送金０も表示する
    </mat-checkbox>
    <a mat-button class="add-link" (click)="newTransaction()">
      <mat-icon>add</mat-icon>単独の送金処理を作成
    </a>
    <a mat-button class="add-link" routerLink="/admin">
      <mat-icon>arrow_back</mat-icon>戻る
    </a>
  </mat-toolbar>

  <div class="list-container" [hidden]="!showGrid">
    <ag-grid-angular
      #grid
      class="ag-theme-alpine"
      style="width: 100%; height: calc(100vh - 350px);"
      [localeText]="localeText"
      [defaultColDef]="defaultColDef"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [pagination]="true"
      [paginationPageSize]="20"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      (cellClicked)="onCellClicked($event)">
    </ag-grid-angular>
  </div>
</div>
